import React, {createContext, useReducer} from 'react'
import {ViewDataReducer} from  "../../reducer/view/DataReducer";
 
export const ViewDataContext = createContext();
 
const ViewDataContextProvider = (props) => {
    const ageingData = {
        isLoading: true,
        metricResult : [],
        packageResultList : [],
        isApplyFilterClicked : true,
        exportResults : [],
        baseURL : "",
        addressFieldsEnabled: false
    }
    const [viewModel, dispatch ] = useReducer(ViewDataReducer, ageingData)
    return (
        <ViewDataContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </ViewDataContext.Provider>
    )
}
 
export default ViewDataContextProvider


// WEBPACK FOOTER //
// ./src/commons/context/view/ViewDataContext.js